import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { programInfo } from "../programsData"; // Import event data
import { Helmet } from "react-helmet";
import "../../styles/posts.css";
import { useTranslation } from "react-i18next";

const SingleProgram = () => {
	const { programId } = useParams();
	const [program, setProgram] = useState(null);
	const { t, i18n } = useTranslation();

	useEffect(() => {
		// Find the event in either upcomingEvents or pastEvents array
		const foundEvent =
		programInfo.find((program) => program.id === programId) 

		// If the event is found, set it in the state
		if (foundEvent) {
			setProgram(foundEvent);
		}
	}, [programId]);

	if (!program) {
		return <div>Loading...</div>;
	}

	// Split the event description into an array of lines
	// const descriptionLines = program.programDescription.split("|");
	// Function to detect URLs and wrap them in anchor tags
	function linkify(text) {
		const urlPattern = /(https?:\/\/[^\s]+)/g;
		return text.split(urlPattern).map((part, index) =>
			urlPattern.test(part) ? (
				<a
					key={index}
					href={part}
					target="_blank"
					rel="noopener noreferrer"
				>
					{part}
				</a>
			) : (
				part
			)
		);
	}

	return (
		<div className="singlePost events">
			<div className="singlePostWrapper singleEventWrapper">
				<h1 className="singlePostTitle">{t(program.nameKey)}</h1>
				<Helmet>
					<title>{t(program.nameKey)}</title>
					<meta name="description" content={t(program.shortDescKey)}/>
				</Helmet>
				<div className="singleEventCard img-height-auto">
					<img src={program.image} alt={t(program.nameKey)} />
					{/* <p className="pt-10">Начало: {program.programDate}</p> */}
				</div>
				{/* Render description lines with clickable links */}
				<div className="program-full-description">
                    {program.description(i18n.language)}
                </div>
				{/* {descriptionLines.map((line, index) => (
					<p className="singlePostDesc pb-5" key={index}>
						{linkify(line)}{" "}
					</p>
				))} */}
			</div>
		</div>
	);
};

export default SingleProgram;
